import { useSelector } from "react-redux"

import { ROLES } from "utils/constants"
import { chatSelector } from "utils/store/selectors/chat"
import { PageHeader } from "components/Header/PageHeader"
import { PsyAccHeader } from "modules/PsychologistAccount/PsyAccHeader"

export function ChatHeader() {
    const { role } = useSelector(chatSelector)
    const isPsy = role === ROLES.PSY

    if (isPsy) return <PsyAccHeader />
    else return <PageHeader openLogo={{ newTab: true }} showRight="menu" />
}
